import React, { useContext } from "react";

// Context
import { ChatContext } from "../../../context/chat/ChatContext";

// Constants
const baseURL = process.env.REACT_APP_API;

/**
 * Pestaña de perfil de chat
 *
 * @returns {JSX.Element} Componente de react
 */
const ProfileTab = () => {
  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  return (
    <>
      <div className="d-flex justify-content-center">
        <img
          src={
            activeChat.foto.includes("http")
              ? activeChat.foto
              : `${baseURL}/${activeChat.foto}`
          }
          alt={activeChat.last_name ?? "Desconocido"}
          className="rounded-circle"
          width="100"
        />
      </div>

      <h4 className="mt-3">Contacto</h4>
      <p className="text-secondary font-14">
        {`${activeChat.first_name ?? ""} ${activeChat.last_name ?? ""}`}
      </p>
    </>
  );
};

export default ProfileTab;
